import { combineReducers } from 'redux';

const initialState = {
    isLoading: false,
    isError: false
};
const spinCarReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET-IS-SPINCAR-LOADING':
            return {
                isLoading: action.data,
                isError: state.isError
            };
        case 'SET-IS-SPINCAR-ERROR':
            return {
                isError: action.data,
                isLoading: state.isLoading
            };

        default:
            return state;
    }
};

export default combineReducers({
    spinCar: spinCarReducer
});
